

























































import { Anagrafica } from "@/data/models/anagrafica.model";
import { Page } from "yellowfin-ui-lib";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import AnagraficaTable from "../albo/anagrafica/AnagraficaTable.vue";
import StpTable from "../albostp/StpTable.vue";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import packageInfo from "../../../package.json";

@Component({
  components: {
    StpTable,
    AnagraficaTable,
  },
})
export default class StpDetail extends Vue {
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;
  albourl: string = "";
  baseurl: string = "";
  anagrafica!: Anagrafica;
  loading = false;

  page?: Page = new Page(100);

  ordine: string | undefined = process.env.VUE_APP_ORDINE;

  get indirizzoText() {
    const s = [];
    if (this.anagrafica.indirizzo) s.push(this.anagrafica.indirizzo);
    if (this.anagrafica.cap) s.push(this.anagrafica.cap);
    if (this.anagrafica.comune) s.push(this.anagrafica.comune);
    if (
      this.anagrafica.provincia &&
      this.anagrafica.provincia != this.anagrafica.comune
    )
      s.push(this.anagrafica.provincia);
    return s.join(" ");
  }

  loadAnagrafica(id: number) {
    this.loading = true;
    this.anagraficaService
      .getAnagrafica(id)
      .then((result) => {
        this.anagrafica = result;
      })
      .finally(() => (this.loading = false));
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);
  }
  mounted() {
    this.albourl = this.$el.parentElement?.getAttribute("data-albo") || "";
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    // const path = location.pathname.split('/');
    const id = params.get("profileid"); //12;//this.$route.query.test;//path[1]
    console.log("beforeMount");
    if (id) {
      this.loadAnagrafica(+id);
    }
    this.baseurl = window.location.href.split("?")[0];
  }
}
